import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/today_task',
      component: () => import('../views/TodayTask'),
    },
    {
      path: '/newbie_task',
      component: () => import('../views/NewbieTask'),
    },
    {
      path: '/introduce',
      component: () => import('../views/Introduce'),
    },
    {
      path: '/explain',
      component: () => import('../views/Explain'),
    },
    {
      path: '/bounty_activity',
      component: () => import('../views/BountyActivity'),
    },
    {
      path: '/ranking_activity',
      component: () => import('../views/RankingActivity'),
    },
    {
      path: '/video',
      component: () => import('../views/Video'),
    },
    {
      path: '/invite',
      component: () => import('../views/Invite'),
    },
    {
      path: '/llzpreview',
      component: () => import('../views/llzPreview'),
    },
    {
      path: '/ranking_shouyou',
      component: () => import('../views/RankingShouyou'),
    },
    {
      path: '/ranking_yizhi',
      component: () => import('../views/RankingYizhi'),
    },
    {
      path: '/ranking_buyu',
      component: () => import('../views/RankingBuyu'),
    },
    {
      path: '/ranking_xianxian',
      component: () => import('../views/RankingXianXian'),
    },
    {
      path: '/strategy',
      component: () => import('../views/GameStrategy'),
    },
    {
      path: '/strategy2',
      component: () => import('../views/IosGameStrategy'),
    },
    {
      path: '/strategy3',
      component: () => import('../views/GameStrategy2'),
    },
    {
      path: '/activity/buyu',
      component: () => import('../views/activity/Buyu'),
    },
    {
      path: '/activity/bill',
      component: () => import('../views/activity/Bill'),
    },
    {
      path: '/feedback',
      component: () => import('../views/Feedback'),
    },
    {
      path: '/help',
      component: () => import('../views/Help'),
    },
    {
      path: '/jz_grade',
      component: () => import('../views/JzGrade'),
    },
    {
      path: '/feedback/record',
      component: () => import('../views/feedback/Record'),
    },
    {
      path: '/feedback/commited',
      component: () => import('../views/feedback/Commit'),
    },
    {
      path: '/feedback/detail',
      component: () => import('../views/feedback/Detail'),
    },
    {
      path: '/rank/shouyou',
      component: () => import('../views/rank/Shouyou'),
    },
    {
      path: '/rank/buyu',
      component: () => import('../views/rank/Buyu'),
    },
    {
      path: '/rank/yizhi',
      component: () => import('../views/rank/Yizhi'),
    },
    {
      path: '/high_reward',
      component: () => import('../views/HighReward'),
    },
    {
      path: '/spin_win',
      component: () => import('../views/SpinWin'),
    },
    {
      path: '/day_redpack',
      component: () => import('../views/DayRedpack'),
    },
    {
      path: '/new_guide',
      component: () => import('../views/NewGuide'),
    },
    {
      path: '/new_rank/shouyou',
      component: () => import('../views/new_rank/Shouyou'),
    },
    {
      path: '/new_rank/buyu',
      component: () => import('../views/new_rank/Buyu'),
    },
    {
      path: '/new_rank/yizhi',
      component: () => import('../views/new_rank/Yizhi'),
    },
    // 每日任务相关
    {
      path: '/daily_task/index',
      component: () => import('../views/daily_task/Index'),
    },
  ],
})

export default router
